import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  icon: PropTypes.bool,
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ icon = false, disabledLink = false, sx }) {
  const theme = useTheme();
  // const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const SECONDARY_MAIN = theme.palette.secondary.main;
  // const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = icon ? (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.12 51.06" width="100%" height="100%">
        <g id="sowan_ar_icon" data-name="Sowan Ar Icon">
          <path
            fill={PRIMARY_MAIN}
            d="M26.69,18.58l2.81-6,7.7-1.44a7.71,7.71,0,0,1-1-3.82A7.55,7.55,0,0,1,38.1,2.12,6,6,0,0,1,42.75,0,6.11,6.11,0,0,1,47.5,2.09a7.55,7.55,0,0,1,1.87,5.25,8.62,8.62,0,0,1-1.84,5.51,7.1,7.1,0,0,1-4.71,2.77ZM43,9.29a2.93,2.93,0,0,0,1.37-2.38c0-1.29-.48-1.94-1.44-1.94s-1.51.65-1.51,1.94A2.76,2.76,0,0,0,43,9.29Z"
          />
          <path
            fill={SECONDARY_MAIN}
            d="M24.26,42.28A42.08,42.08,0,0,1,34.34,25.21q7.35-7.34,16.85-7.34,8.51,0,13.61,5.9a18.12,18.12,0,0,1,4.32,12.32v1.58q0,6.55-4.1,10.22a13.15,13.15,0,0,1-9.15,3.17H24.77a13.3,13.3,0,0,1-8.71-2.81,13.35,13.35,0,0,1-8.72,2.81H0V42.35H6.48a5.29,5.29,0,0,0,3.89-1.19,5.61,5.61,0,0,0,1.15-4V23.66l9.07-.75V37.17C20.59,40.24,21.82,41.94,24.26,42.28Zm35.79-5.19v-1A10.2,10.2,0,0,0,57.6,29a8.12,8.12,0,0,0-6.34-2.74,15.5,15.5,0,0,0-10.47,4.32,29.18,29.18,0,0,0-7.67,11.74H55.51c1.73,0,2.92-.37,3.57-1.12S60.05,39.11,60.05,37.09Z"
          />
        </g>
      </svg>
    </Box>
  ) : (
    <Box sx={{ width: 96, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152.19 64.27" width="100%" height="100%">
        <g id="sowan_ar" data-name="Sowan Ar">
          <path fill={SECONDARY_MAIN} d="M18.5,18.7H15c0-2.13-.65-7.7,3.52-7.13C23.17,11.08,23.11,19.19,18.5,18.7Z" />
          <path
            fill={SECONDARY_MAIN}
            d="M37.37,46.71q0,8.26-5.76,13.17-5.12,4.4-13.11,4.39Q9.14,64.27,4,57.65a19.18,19.18,0,0,1-4-12.1A17.64,17.64,0,0,1,3,35.19l6-1.3a20.21,20.21,0,0,0-3.24,11A13.74,13.74,0,0,0,9.5,54.84a12.09,12.09,0,0,0,9,3.6q6.34,0,9.8-3.67a11.35,11.35,0,0,0,2.88-8.06v-27l6.19-.31Z"
          />
          <path fill={SECONDARY_MAIN} d="M43.73,50.59V4.47l6.19-.32V50.59Z" />
          <path
            fill={SECONDARY_MAIN}
            d="M83.07,50.59a13.4,13.4,0,0,1-5.32,10.23,15.34,15.34,0,0,1-9.65,3.31A17.84,17.84,0,0,1,59.67,62V56.57a16.17,16.17,0,0,0,7.56,2,10.07,10.07,0,0,0,6.66-2.38,7.41,7.41,0,0,0,2.92-5.69c-2.5-.09-4.34-.19-5.54-.29-5.19-.28-9.1-2-11.74-5.25a15.91,15.91,0,0,1-3.31-10.44q0-7.84,4.17-12.24a13.1,13.1,0,0,1,9.87-3.89q6.4,0,9.86,3.82a12.94,12.94,0,0,1,2.95,8.85V50.59ZM76.81,31.51q0-7.34-6.55-7.34a6.94,6.94,0,0,0-5.83,2.7c-1.4,1.8-2.09,4.31-2.09,7.52q0,9.44,9.21,10c1.16.15,2.91.27,5.26.36Z"
          />
          <path
            fill={PRIMARY_MAIN}
            d="M109.76,18.58l2.81-6,7.71-1.44a7.61,7.61,0,0,1-1-3.82,7.51,7.51,0,0,1,1.91-5.22A6,6,0,0,1,125.82,0a6.11,6.11,0,0,1,4.75,2.09,7.55,7.55,0,0,1,1.87,5.25,8.67,8.67,0,0,1-1.83,5.51,7.14,7.14,0,0,1-4.72,2.77ZM126,9.29a2.91,2.91,0,0,0,1.36-2.38C127.4,5.62,126.92,5,126,5s-1.51.65-1.51,1.94A2.75,2.75,0,0,0,126,9.29Z"
          />
          <path
            fill={SECONDARY_MAIN}
            d="M107.34,42.28a41.86,41.86,0,0,1,10.08-17.07q7.33-7.34,16.85-7.34,8.49,0,13.61,5.9a18.12,18.12,0,0,1,4.31,12.32v1.58q0,6.55-4.1,10.22A13.12,13.12,0,0,1,139,51.06H107.84a13.32,13.32,0,0,1-8.71-2.81,13.32,13.32,0,0,1-8.71,2.81H83.07V42.35h6.48a5.28,5.28,0,0,0,3.89-1.19,5.61,5.61,0,0,0,1.15-4V23.66l9.08-.75V37.17Q103.67,41.78,107.34,42.28Zm35.78-5.19v-1A10.15,10.15,0,0,0,140.67,29a8.11,8.11,0,0,0-6.33-2.74,15.5,15.5,0,0,0-10.48,4.32,29.29,29.29,0,0,0-7.67,11.74h22.4c1.72,0,2.91-.37,3.56-1.12S143.12,39.11,143.12,37.09Z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
